import(/* webpackMode: "eager", webpackExports: ["Page"] */ "/Users/erikkoning/Documents/Work/RefDocs/refdocs-app-sst/packages/app-core/src/app/(auth)/signin/client.tsx");
